let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kylxz")).then(() => parcelRequire('8k3Dp'));